<div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
  <div
    class="max-w-md w-full text-center bg-white p-10 rounded-2xl shadow-xl border border-gray-100"
  >
    <div class="text-6xl mb-6 animate-bounce">🔍</div>

    <h1 class="text-3xl font-bold text-gray-900 mb-3">Are you lost?</h1>
    <p class="text-gray-600 mb-8 leading-relaxed">
      We couldn't find the survey you're looking for. The link might be broken,
      expired, or moved to a new home.
    </p>

    <div class="flex flex-col sm:flex-row gap-3 justify-center">
      <button
        (click)="goHome()"
        class="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition-all duration-200 transform hover:-translate-y-1 shadow-md"
      >
        Back to Home
      </button>

      <button
        (click)="contactSupport()"
        class="px-6 py-3 bg-white hover:bg-gray-50 text-gray-700 font-semibold rounded-lg border border-gray-300 transition-all duration-200"
      >
        Contact Support
      </button>
    </div>
  </div>
</div>
